import scrollDir from "scrolldir";
import { invalidInputFocus } from "../../../shared/components/form/js/invalidInputFocus";
import { AccordionItems } from "../../../shared/components/accordion-item";
import LazyLoad from "vanilla-lazyload";
import "./js/scrolltoelement";

document.addEventListener("DOMContentLoaded", () => {
  new invalidInputFocus();
  new AccordionItems();
  scrollDir();

  const lazyImages = document.querySelectorAll("img.lazy");
  if (lazyImages.length) {
    addHeightToLazyLoadImages(lazyImages);
  }

  const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    callback_loaded: (el) => {
      if (el.tagName.toLowerCase() === "img") {
        el.removeAttribute("style");
      }
    },
  });
});

const addHeightToLazyLoadImages = (lazyImages) => {
  [].forEach.call(lazyImages, (image) => {
    if (!image.classList.contains("loaded")) {
      const imageHeight = image.dataset.height;
      const imageWidth = image.dataset.width;

      image.style.paddingBottom = `${imageHeight / (imageWidth / 125)}%`;
    }
  });
};
